import api from "./api";

class AnaliseHistoricoAPI {
  /**
   * Lista todas as bases historicas importadas
   */
  async getBases(headers) {
    return api.get("/analise/bases", { headers });
  }

  /**
   * Importa uma nova base historica (legado - via JSON)
   */
  async importarBase(headers, dados) {
    return api.post("/analise/importar", dados, { headers });
  }

  /**
   * Importa uma nova base historica via upload de arquivo XLSX
   */
  async importarArquivo(headers, arquivo, nomeBase, anoReferencia, mapeamento) {
    const formData = new FormData();
    formData.append('arquivo', arquivo);
    formData.append('nome_base', nomeBase);
    formData.append('ano_referencia', anoReferencia);
    formData.append('mapeamento', JSON.stringify(mapeamento));

    return api.post("/analise/importar-arquivo", formData, {
      headers: {
        ...headers,
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  /**
   * Retorna assessores pendentes de vinculacao de uma base
   */
  async getAssessoresPendentes(headers, idBase) {
    return api.get(`/analise/assessores-pendentes/${idBase}`, { headers });
  }

  /**
   * Vincula manualmente um assessor historico a um usuario atual
   */
  async vincularAssessor(headers, dados) {
    return api.post("/analise/vincular-assessor", dados, { headers });
  }

  /**
   * Remove uma base historica
   */
  async delBase(headers, id) {
    return api.delete(`/analise/base/${id}`, { headers });
  }

  /**
   * Retorna todos os assessores pendentes de todas as bases com contagem de
   * pessoas bloqueadas e sugestoes por similaridade de nome
   */
  async getAssessoresPendentesTodos(headers) {
    return api.get("/analise/assessores-pendentes-todos", { headers });
  }

  /**
   * Compara duas bases (A = origem, B = destino, "atual" = cadastro ativo):
   * resumo global, detalhamento por assessor (com score de renovacao) e pares "a revisar"
   */
  async compararBases(headers, baseA, baseB) {
    return api.get("/analise/comparar-bases", { params: { base_a: baseA, base_b: baseB }, headers });
  }

  /**
   * Lista pessoas de um grupo (repetidas | novas | saiu | trocou) de um assessor na comparacao entre bases
   */
  async compararBasesPessoas(headers, idAssessor, baseA, baseB, tipo) {
    const id = idAssessor == null ? 0 : idAssessor;
    return api.get(`/analise/comparar-bases/assessor/${id}/pessoas`, {
      params: { base_a: baseA, base_b: baseB, tipo },
      headers
    });
  }

  /**
   * Lista global das pessoas de um grupo (repetidas | novas | saiu) na comparacao entre bases
   */
  async compararBasesPessoasGlobal(headers, baseA, baseB, tipo) {
    return api.get("/analise/comparar-bases/pessoas", {
      params: { base_a: baseA, base_b: baseB, tipo },
      headers
    });
  }

  /**
   * Confirma um par "a revisar" como sendo a mesma pessoa
   */
  async confirmarMatchRevisao(headers, payload) {
    return api.post("/analise/comparar-bases/confirmar-revisao", payload, { headers });
  }

  /**
   * Confirma varios pares "a revisar" de uma vez
   */
  async confirmarMatchRevisaoLote(headers, payload) {
    return api.post("/analise/comparar-bases/confirmar-revisao-lote", payload, { headers });
  }
}

export default new AnaliseHistoricoAPI();
